const compState = {
  namespaced: true,
  state: {
    activePage: 'Wait for fix',
    subActivePage: 'Wait for fix'
  },
  getters: {
    getPage: state => {
      return state
    }
  },
  mutations: {
    setActivePage: (state, page) => {
      state.activePage = page
    },
    setSubActivePage: (state, page) => {
      state.subActivePage = page
    }
  },
  actions: {
    changePage: ({ commit, state }, page) => {
      commit('setActivePage', page.activePage)
      commit('setSubActivePage', page.subActivePage)
    }
  }

}

export default compState
